__turbopack_context__.v({
  "ActivityLog": "ActivityLog-module-scss-module__lSMsWG__ActivityLog",
  "ActivityLog__footnote": "ActivityLog-module-scss-module__lSMsWG__ActivityLog__footnote",
  "ActivityLog__header": "ActivityLog-module-scss-module__lSMsWG__ActivityLog__header",
  "ActivityLog__link": "ActivityLog-module-scss-module__lSMsWG__ActivityLog__link",
  "ActivityLog__list": "ActivityLog-module-scss-module__lSMsWG__ActivityLog__list",
  "ActivityLog__oneColumn__timestamp": "ActivityLog-module-scss-module__lSMsWG__ActivityLog__oneColumn__timestamp",
  "ActivityLog__scrollbody": "ActivityLog-module-scss-module__lSMsWG__ActivityLog__scrollbody",
  "ActivityLog__timestamp": "ActivityLog-module-scss-module__lSMsWG__ActivityLog__timestamp",
  "ActivityLog_separator": "ActivityLog-module-scss-module__lSMsWG__ActivityLog_separator",
});
